// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3qiE7","notes":"Notes_notes__3gBEW"};